import React, { FC } from 'react'

interface Props {
  type: 'danger' | 'success' | string // TODO: Remove the type of `string`
  msg: string
  className?: string
}

const Alert: FC<Props> = ({ type, msg, className = '' }) => {
  return <div className={`alert alert-${type} ${className}`} role="alert" dangerouslySetInnerHTML={{ __html: msg }} />
}

export default Alert
